import Vue from 'vue'
import Router from 'vue-router'
import gk from '@/components/gk'
import zk from '@/components/zk2023'
import art from '@/components/art'
import ga from '@/components/ga' // 港澳台
import gzgk from '@/components/gzgk' // 高职高考
import yixuekao from '@/components/yixuekao' //春季高考 依学考
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'yixuekao',
      component: yixuekao
      // },
      // // {
      // path: '/',
      // name: 'zk',
      // component: zk
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js